// Core
import React from 'react';
import { Box, Button, Flex, Text, Divider, Grid, Image } from '@chakra-ui/react';
import { NavLink } from 'react-router-dom';

// Assets
import coin from 'assets/img/details/coin-1.png';
import crystal from 'assets/img/details/crystal-3.png';
import box from 'assets/img/details/box.png';
import ticket from 'assets/img/details/ticket.png';
import wheel from 'assets/img/details/wheel.png';
import BecomeAPartners from 'components/Sliders/BecomeAPartners';
import { ReactComponent as Lines } from 'assets/svg/lines.svg';

// Components
import Card from 'components/Card/Card';
import { StarsIcon } from '../../../components/Icons/Icons';

const Partners = () => {
	const textColor ='white'; 

    return (
    	<Card
    		mt="32px"
    		textAlign="center"
    		border="1px solid rgba(255, 255, 255, 0.1))"
    		overflow="hidden"
    		p="36px"
    		className="animation-bap-partners"
			background="linear-gradient(180deg, #099BFF 0%, #9ED3F8 82.5%)">
			
			<BecomeAPartners />

			<Box zIndex="2" mt="64px" mb={{ base: '200px', md: '0'}}>
				<Text variant="header" p={{sm: '0px', md: '0 36%'}} letterSpacing="0" fontSize="16px" color={textColor}>Here are some of the partners we continue to work with.</Text>
				<Text variant="header" fontSize={{base: '64px', md: '80px'}} mt={{base: '8px', md: '24px'}} color={textColor}>Become</Text>
				<Flex alignItems="center" gap="11px" m="-8px auto !important" borderRadius="16px" p="3px 24px" background="white" w="max-content">
					<Text variant="header-gradient" fontSize={{base: '32px', md: '72px'}}>our</Text>
		        	<StarsIcon fontSize={{base: '24px', md: '42px'}}  />
		        	<Text variant="header-gradient" fontSize={{base: '32px', md: '72px'}}>partner</Text>
		        </Flex>
		        <Text variant="header" fontSize={{base: '64px', md: '80px'}} color={textColor}>today!</Text>
		        <NavLink to="/partner-with-us"><Button variant="button-lg" w="280px" mt="9px" mb="4px">Become A Partner</Button></NavLink>
			</Box>
			
			<Lines className="abstract-lines" style={{zIndex: 1, left: '18%', transform: 'scale(1.5)'}} />
			<Box position="absolute" bottom="0px" w="100%" left="0" zIndex="1" className="animation-bap-partners-scale">
				<Image src={crystal} alt="crystal" position="absolute" left="-112px" bottom="127px" transform="rotate(334deg)" width="210px" />
				<Image src={crystal} alt="crystal" position="absolute" left="18px" bottom="132px" transform="rotate(335deg)" width="180px" />
				<Image src={crystal} alt="crystal" position="absolute" left="-83px" bottom="-32px" transform="rotate(32deg)" width="200px" zIndex="8" />
				<Image src={crystal} alt="crystal" position="absolute" left="41px" bottom="-36px" transform="rotate(37deg)" width="172px" zIndex="5" />
				<Image src={coin} alt="coin" position="absolute" left="-42px" bottom="23px" transform="rotate(31deg)" width="196px" zIndex="4" />
				<Image src={coin} alt="coin" position="absolute" left="130px" bottom="-85px" transform="rotate(8deg)" width="250px" zIndex="3" />
				<Image src={box} alt="box" position="absolute" left="80px" bottom="-15px" transform="rotateY(-180deg) rotate(-12deg)" width="220px" zIndex="2" />
			</Box>
			<Box position="absolute" bottom="0px" w="100%" right="0" zIndex="1" className="animation-bap-partners-scale">
				<Image src={crystal} alt="crystal" position="absolute" right="102px" bottom="-55px" width="174px" transform="rotate(-17deg)" zIndex="8" />
				<Image src={crystal} alt="crystal" position="absolute" right="-82px" bottom="31px" width="174px" transform="rotate(49deg)" zIndex="2" />
				<Image src={crystal} alt="crystal" position="absolute" right="-12px" bottom="72px" width="210px" transform="rotate(2deg)" zIndex="1"  />
				<Image src={crystal} alt="crystal" position="absolute" right="-34px" bottom="171px" width="165px" transform="rotate(-3deg)" zIndex="1"  />
				<Image src={coin} alt="coin" position="absolute" right="-66px" bottom="109px" width="155px" transform="rotate(31deg)" zIndex="1" />
				<Image src={ticket} alt="ticket" position="absolute" right="168px" bottom="-56px" width="170px" transform="rotate(67deg)" zIndex="7" />
				<Image src={wheel} alt="wheel" position="absolute" right="0px" bottom="-84px" width="380px" transform="rotate(10deg)" zIndex="5" />
			</Box>
    	</Card>
    );
};


export default Partners;